// extracted by mini-css-extract-plugin
export default {"dropdown_container":"DropdownMenu_dropdown_container__XSxQA","dropdown_menu":"DropdownMenu_dropdown_menu__TjR8H","_dropdown_item":"DropdownMenu__dropdown_item__QQnie"};